"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const launchdarkly_client_provider_1 = require("@openfeature/launchdarkly-client-provider");
const contexts_1 = require("@App/contexts");
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const react_sdk_1 = require("@openfeature/react-sdk");
const open_feature_user_context_1 = __importDefault(require("@App/helpers/user/open-feature-user-context"));
const userpilot_1 = require("userpilot");
const user_pilot_user_context_1 = __importDefault(require("@App/helpers/user/user-pilot-user-context"));
const react_router_dom_1 = require("react-router-dom");
const ldOpenFeatureProvider = new launchdarkly_client_provider_1.LaunchDarklyClientProvider(process.env.LAUNCH_DARKLY_CLIENT_ID || '', {});
const userPilotToken = process.env.USER_PILOT_TOKEN || '';
const UserInfoHandler = (props) => {
    const location = (0, react_router_dom_1.useLocation)();
    const { userStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { children } = props;
    (0, react_1.useEffect)(() => {
        userpilot_1.Userpilot.initialize(userPilotToken);
    }, []);
    react_1.default.useEffect(() => {
        userpilot_1.Userpilot.reload();
    }, [location]);
    (0, react_1.useEffect)(() => {
        const userInfo = userStore.userInfo;
        void react_sdk_1.OpenFeature.setProviderAndWait(ldOpenFeatureProvider, (0, open_feature_user_context_1.default)(userInfo));
        if (userInfo) {
            (0, analytics_utils_1.analyticsSendIdentify)(userInfo);
            // identity only authenticated users to Userpilot to avoid tracking
            // anonymous users as MAUs
            const userId = userInfo.id || '';
            userpilot_1.Userpilot.identify(userId, (0, user_pilot_user_context_1.default)(userInfo));
            // Recommended to call reload() after user identification
            // details change to immediately sync with Userpilot
            userpilot_1.Userpilot.reload();
        }
    }, [userStore.userInfo]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_sdk_1.OpenFeatureProvider, null, children)));
};
exports.default = UserInfoHandler;
